// extracted by mini-css-extract-plugin
export var blurInAnimation = "VimeoPlayer-module--blur-in-animation--9864a";
export var fadeInAnimation = "VimeoPlayer-module--fade-in-animation--2e8ee";
export var loaded = "VimeoPlayer-module--loaded--b9c3b";
export var placeholder = "VimeoPlayer-module--placeholder--eb9e1";
export var videoPlayer = "VimeoPlayer-module--videoPlayer--15814";
export var wrapper = "VimeoPlayer-module--wrapper--a484d";